
export default {
    components: {},
    props: {
        size: {
            type: [String, Number],
            default: 20
        },
        show: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            style: {
                height: this.size + 'px',
                width: this.size + 'px'
            },
            theme: 'light',
            filter: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><filter id="dark-mode-filter" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0.283 -0.567 -0.567 0 0.925 -0.567 0.283 -0.567 0 0.925 -0.567 -0.567 0.283 0 0.925 0 0 0 1 0"/></filter></svg>#dark-mode-filter')`,
            reverseFilter: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg"><filter id="dark-mode-reverse-filter" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0.333 -0.667 -0.667 0 1 -0.667 0.333 -0.667 0 1 -0.667 -0.667 0.333 0 1 0 0 0 1 0"/></filter></svg>#dark-mode-reverse-filter')`,
            originThemeColor: '#159f95',
            darkThemeColor: '#131313'
        }
    },

    head() {
        return {
            meta: [
                {
                    hid: 'theme',
                    name: 'theme-color',
                    content: this.theme === 'dark' ? this.darkThemeColor : this.originThemeColor
                }
            ]
        }
    },
    mounted() {
        this.theme = localStorage.getItem('pz-theme') || 'light'
        this.changeTheme(this.theme)
    },
    methods: {
        changeTheme(theme) {
            this.theme = theme
            if (this.theme === 'dark') {
                //this.addThemeColor(this.darkThemeColor);
                document.getElementsByTagName('html')[0].setAttribute('dark', true)
                this.createDarkStyle()
            } else {
                //this.addThemeColor(this.originThemeColor);
                document.getElementsByTagName('html')[0].removeAttribute('dark')
                this.removeElementById('dark-mode-style')
            }
            localStorage.setItem('pz-theme', this.theme)
        },

        removeElementById(eleId) {
            let ele = document.getElementById(eleId)
            ele && ele.parentNode.removeChild(ele)
        },

        addStyle(id, tag, css) {
            tag = tag || 'style'
            let doc = document,
                styleDom = doc.getElementById(id)
            if (styleDom) return
            let style = doc.createElement(tag)
            style.rel = 'stylesheet'
            style.id = id
            tag === 'style' ? (style.innerHTML = css) : (style.href = css)
            document.head.appendChild(style)
        },

        addThemeColor(color) {
            let doc = document,
                meta = doc.getElementsByName('theme-color')[0]
            if (meta) return meta.setAttribute('content', color)
            let metaEle = doc.createElement('meta')
            metaEle.name = 'theme-color'
            metaEle.content = color
            doc.head.appendChild(metaEle)
        },

        createDarkStyle() {
            this.addStyle(
                'dark-mode-style',
                'style',
                `body{background-color:#010409;}html{-webkit-filter:${this.filter}!important;filter:${this.filter}!important;scrollbar-color:#454a4d #202324!important;text-shadow:0 0 0 !important;background:#fafafa !important;}.nav-header .nav-ul li .active,.el-menu-item.topMenu.is-active,.is-active.is-opened .el-submenu__title,.info-box .left,.name span.mr-20,.submit-red-jianbian-btn,.red-jianbian-btn,.blue-jianbian-btn,.user-box,.red-btn,.swiper-count,.left-img,.wx-box .title,img,video,canvas,:not(object):not(body) > embed,object,svg image,[style*="background:url"],[style*="background-image:url"],[style*="background:url"],[style*="background-image:url"],[background],.el-image-viewer__mask,.el-image-viewer__btn,.svg-logo,.icon-svg,.no-dark-mode{-webkit-filter:${this.reverseFilter}!important;filter:${this.reverseFilter}!important;}[style*="background:url"] *,[style*="background-image:url"] *,[style*="background:url"] *,[style*="background-image:url"] *,input,[background] *{-webkit-filter:none!important;filter:none!important;}.no-filter,:-webkit-full-screen,:-webkit-full-screen *,:-moz-full-screen,:-moz-full-screen *,:fullscreen,:fullscreen *{-webkit-filter:none!important;filter:none!important;}::-webkit-scrollbar{background-color:#202324;color:#aba499;}::-webkit-scrollbar-thumb{border-radius:0;background-color:#454a4d;}::-webkit-scrollbar-thumb:hover{background-color:#575e62;}::-webkit-scrollbar-thumb:active{background-color:#484e51;}::-webkit-scrollbar-corner{background-color:#181a1b;}::-webkit-scrollbar-track{border-radius:0;background-color:#202324;}`
            )
        }
    }
}
